export const TEST_ID = 'detailCard';
